handlebarTemplateJS = function (selector, htmlSelector, data) {
  let selectorElement = document.querySelector(selector);
  let theTemplateScript = selectorElement.innerHTML;
  let theTemplate = Handlebars.compile(theTemplateScript);
  let theCompiledHtml = theTemplate(data);
  document.querySelector(htmlSelector).innerHTML = theCompiledHtml;
};

handlebarTemplateGamePlay = function (selector, htmlSelector, data) {
  let selectorElement = document.querySelector(selector);
  let theTemplateScript = selectorElement.innerHTML;
  let theTemplate = Handlebars.compile(theTemplateScript);
  let theCompiledHtml = theTemplate(data);
  // append the raw HTML to the game-play div using .append()
  document
    .querySelector(htmlSelector)
    .insertAdjacentHTML("beforeend", theCompiledHtml);
};

Handlebars.registerHelper("checkLength", function (v1, v2, options) {
  if (v1.length > v2) {
    return options.fn(this);
  }
  return options.inverse(this);
});
Handlebars.registerHelper("increment", function (value, options) {
  return parseInt(value) + 1;
});
Handlebars.registerHelper("divide", function (value1, value2) {
  return value1 / value2;
});
Handlebars.registerHelper("multiply", function (value1, value2) {
  return value1 * value2;
});
Handlebars.registerHelper("ifCond", function (v1, operator, v2, options) {
  switch (operator) {
    case "==":
      return v1 == v2 ? options.fn(this) : options.inverse(this);
    case "===":
      return v1 === v2 ? options.fn(this) : options.inverse(this);
    case "!=":
      return v1 != v2 ? options.fn(this) : options.inverse(this);
    case "!==":
      return v1 !== v2 ? options.fn(this) : options.inverse(this);
    case "<":
      return v1 < v2 ? options.fn(this) : options.inverse(this);
    case "<=":
      return v1 <= v2 ? options.fn(this) : options.inverse(this);
    case ">":
      return v1 > v2 ? options.fn(this) : options.inverse(this);
    case ">=":
      return v1 >= v2 ? options.fn(this) : options.inverse(this);
    case "&&":
      return v1 && v2 ? options.fn(this) : options.inverse(this);
    case "||":
      return v1 || v2 ? options.fn(this) : options.inverse(this);
    default:
      return options.inverse(this);
  }
});
Handlebars.registerHelper("pagination", function (n, block) {
  var accum = "";
  for (var i = 1; i <= n; ++i) accum += block.fn(i);
  return accum;
});
Handlebars.registerHelper("add", function (a, b) {
  return a + b;
});
Handlebars.registerHelper("sub", function (a, b) {
  return a - b;
});
Handlebars.registerHelper("translate", function (string) {
  let mainComponent = document.querySelector("#wl-game-integration-plugin");
  let language = mainComponent.dataset.language;
  let translationData = JSON.parse(settings.plugin_translations);
  if (translationData[string] && translationData[string][language]) {
    return translationData[string][language];
  } else {
    return string;
  }
});
translate = function (language, string) {
  let translationData = JSON.parse(settings.plugin_translations);
  if (translationData[string] && translationData[string][language]) {
    return translationData[string][language];
  } else {
    return string;
  }
};
tournamentStartAndEndTime = function () {
  const startTime = document.querySelectorAll("[data-tournament-start-time]");
  const endTime = document.querySelectorAll("[data-tournament-end-time]");
  const monthNames = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ];
  if (startTime.length >= 1) {
    updateUserTime(startTime, "tournamentStartTime");
  }

  if (endTime.length >= 1) {
    updateUserTime(endTime, "tournamentEndTime");
  }

  function updateUserTime(timers, dataAttribute) {
    timers.forEach((el) => {
      const timer = el;
      const singleTime = timer.dataset[dataAttribute] * 1000;
      let dateObj = new Date(singleTime);
      let date =
        ("0" + dateObj.getDate()).slice(-2) +
        ". " +
        monthNames[dateObj.getMonth()] +
        " " +
        dateObj.getFullYear();
      let time =
        ("0" + dateObj.getHours()).slice(-2) +
        ":" +
        ("0" + dateObj.getMinutes()).slice(-2);
      timer.innerHTML = date + " " + time;
    });
  }
};

tournamentTimer = function () {
  const timers = document.querySelectorAll("[data-tournament-timer]");

  if (timers.length >= 1) {
    timers.forEach((el) => {
      const timer = el;
      const singleTime = timer.dataset.tournamentTimer * 1000;
      if (singleTime > 1) {
        var timerInterval = setInterval(() => {
          updateTournamentTimer(singleTime, timer);
        }, 1000);
      } else {
        const timerNumbers = timer.querySelectorAll(
          "[data-tournament-timer-number-list]"
        );
        timerNumbers.forEach((el) => {
          const singleTimer = el;
          singleTimer.innerHTML = "0";
        });
      }
    });
  }

  function updateTournamentTimer(time, timer) {
    const now = new Date().getTime();
    const timeLeft = time - now;
    let numbersData = [];

    numbersData["days"] = Math.floor(timeLeft / (1000 * 60 * 60 * 24));
    numbersData["hours"] = Math.floor(
      (timeLeft % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
    ).toLocaleString("en-US", {
      minimumIntegerDigits: 2,
      useGrouping: false,
    });
    numbersData["minutes"] = Math.floor(
      (timeLeft % (1000 * 60 * 60)) / (1000 * 60)
    ).toLocaleString("en-US", {
      minimumIntegerDigits: 2,
      useGrouping: false,
    });
    numbersData["seconds"] = Math.floor(
      (timeLeft % (1000 * 60)) / 1000
    ).toLocaleString("en-US", {
      minimumIntegerDigits: 2,
      useGrouping: false,
    });
    const timerNumbers = timer.querySelectorAll(
      "[data-tournament-timer-number-list]"
    );

    timerNumbers.forEach((el) => {
      const singleTimer = el;
      const type = singleTimer.dataset.tournamentTimerNumberList;
      if (numbersData[type] >= 0) {
        singleTimer.innerHTML = numbersData[type];
      } else {
        if (type == "days") {
          singleTimer.innerHTML = "0";
        } else {
          singleTimer.innerHTML = "00";
        }
      }
    });
  }
};
